import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

const Crop = (props) => (
  <SvgIcon {...props}>
    <svg fill={props.color} height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z"/>
    </svg>
  </SvgIcon>
);

export default Crop;


// WEBPACK FOOTER //
// ./src/icons/CropIcon.jsx